import { render, staticRenderFns } from "./AttendanceJustificationMain.vue?vue&type=template&id=af81353c"
import script from "./AttendanceJustificationMain.vue?vue&type=script&lang=js"
export * from "./AttendanceJustificationMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports